import { render, staticRenderFns } from "./ProductCP6.vue?vue&type=template&id=0ee19492&scoped=true&"
import script from "./ProductCP6.vue?vue&type=script&lang=js&"
export * from "./ProductCP6.vue?vue&type=script&lang=js&"
import style0 from "./ProductCP6.vue?vue&type=style&index=0&id=0ee19492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee19492",
  null
  
)

export default component.exports